<template>
  <div class="wt2-rebrand">
    <div class="-title wt2-text-l2">{{ 'rebrand.title' | culture }}</div>
    <div class="wt2-text-s -message">{{ 'rebrand.message' | culture }}</div>

    <div class="-programmer">
      <span class="wt2-color-black">{{
        'rebrand.productionLine' | culture
      }}</span>
      <wt-brands-dropdown
        :organization-id="selectedOrganizationId"
        :current-brand.sync="currentBrand"
        :filter-by-aspect-ratio="story.aspectRatio"
        :show-single="true"
      />
      <div
        v-if="!currentOrganizationBrands.length"
        class="wt2-color-error"
        v-text="noBrands4aspectRatio"
      />
    </div>

    <div class="-aspect-ratio" v-if="aspectRatioLabel">
      <span class="wt2-color-black">{{ 'rebrand.aspectRatio' | culture }}</span>
      <span class="-aspect-ratio-val">{{ aspectRatioLabel }}</span>
    </div>

    <div class="-actions" v-tab-guard>
      <wt-button
        class="-min-width-unset"
        tabindex="0"
        type="transparent"
        :text="'generic.CANCEL' | culture"
        @click="closeModal"
      />
      <wt-button
        :text="'rebrand.buttonProduce' | culture"
        tabindex="-1"
        :disabled="!canRebrand"
        @click="rebrandVideo"
      />
    </div>
  </div>
</template>

<script>
import app from 'app';
import { DuplicateController } from 'c/DuplicateController';
import WtBrandsDropdown from '#/components/dropdowns/wtBrandsDropdown.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: { WtBrandsDropdown },
  store() {
    return app.rootStore;
  },

  props: {
    closeModal: { type: Function, required: true },
    story: { type: Object, required: true },
    source: { type: String, required: true },
  },

  data() {
    return {
      currentBrand: null,
    };
  },

  computed: {
    ...mapState('user', ['selectedOrganizationId']),
    ...mapGetters('user', ['selectedOrganization']),

    aspectRatioLabel() {
      const aspectRatio = app.ASPECT_RATIOS[this.story.aspectRatio];
      return (
        aspectRatio && `${aspectRatio.friendlyName} ${aspectRatio.friendlyVal}`
      );
    },

    currentOrganizationBrands() {
      return this.selectedOrganization.brands.filter((brand) =>
        brand.themes.find(
          (theme) => theme.aspectRatio === this.story.aspectRatio
        )
      );
    },

    canRebrand() {
      return !!this.currentBrand;
    },

    noBrands4aspectRatio() {
      return app.culture
        .get('makeCopyDialog.noBrands4aspectRatio')
        .format(app.ASPECT_RATIOS[this.story.aspectRatio].friendlyVal);
    },
  },

  methods: {
    rebrandVideo() {
      if (!this.canRebrand) {
        return;
      }

      const brandTheme = this.currentBrand.themes.find(
        (theme) => theme.aspectRatio === this.story.aspectRatio
      );

      DuplicateController.rebrand(
        {
          story: this.story,
          programmerId: this.currentBrand.programmerId,
          storyStartPoint: app.storyStartPoint.INSTANT,
          brandId: this.currentBrand.brandId,
          themeId: brandTheme.themeId,
        },
        {
          source: this.source,
        }
      ).then(
        (data) => {
          this.closeModal();
          app.navigate(`videos/producing/${data.storyId}`);
        },
        () => {
          app.delayedSpinner.hide();
        }
      );
    },
  },
};
</script>
